import React from "react"

const Avatar = ({ src }) => {
    return (
        <div className="d-flex justify-content-center">
            <img src={src} alt="ejemplo" className="rounded-circle" style={{ width: '50%', height: '50%' }} />
        </div>
    )
}


export default Avatar